function createFacebookLink({ parent, link }) {
  const uri = 'https://www.facebook.com/dialog/share?';
  const env = parent.$store.state.env;
  const href = encodeURIComponent(`${env.APP_URL}${link || parent.$route.path}`);

  return `${uri}app_id=${env.FACEBOOK_CLIENT_ID}&display=popup&href=${href}`;
}

function createTwitterLink({ parent, text, link }) {
  const uri = 'https://twitter.com/intent/tweet?';
  const env = parent.$store.state.env;
  const url = encodeURIComponent(`${env.APP_URL}${link || parent.$route.path}`);

  return `${uri}url=${url}&via=baianat&text=${encodeURIComponent(text)}`;
}

function createPinterestLink({ parent, text, image, link }) {
  const uri = 'http://pinterest.com/pin/create/link/?';
  const env = parent.$store.state.env;
  const url = encodeURIComponent(`${env.APP_URL}${link || parent.$route.path}`);

  return `${uri}url=${url}&media=${encodeURIComponent(image)}&description=${text}`;
}

function createProviderShareLink(provider, { text, parent, image, link }) {
  const linksFactory = {
    facebook: createFacebookLink,
    twitter: createTwitterLink,
    pinterest: createPinterestLink
  };

  if (!linksFactory[provider]) {
    throw new Error(`Cannot create a share link for ${provider}.`);
  }

  return linksFactory[provider]({ text, parent, image, link });
}

export default {
  name: 'ShareButton',
  functional: true,
  props: {
    provider: {
      provider: String,
      required: true
    },
    text: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    }
  },
  render(h, { props, parent }) {
    return h(
      'a',
      {
        attrs: {
          target: '_blank',
          rel: 'noopener',
          href: createProviderShareLink(props.provider, {
            text: props.text,
            image: props.image,
            parent,
            link: props.link
          })
        }
      },
      [
        h('AppIcon', {
          props: {
            name: props.provider
          }
        })
      ]
    );
  }
};
